module.exports = __webpack_public_path__ + "static/img/params.c644ad80.png";